import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { MfaSettings, SecureTabs } from '../../../components';
import { ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const MultiFactorAuthentication = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { error } = useCurrentProject(projectId);

  if (error) {
    return <ToDashboardError error={error} pageName="mfa-settings_open" />;
  }

  return (
    <SecureTabs>
      <MfaSettings />
    </SecureTabs>
  );
};

export default withRouter(MultiFactorAuthentication);
